/* ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|      CORE LIBS      |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ */
import 'es6-promise/auto'
//import 'es7-shim'
import _ from 'lodash'
import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/tr-TR'
import Vuebar from 'vuebar'
import vClickOutside from 'v-click-outside'
import VueFloatLabel from 'vue-float-label'
import VuePerfectScrollbar from './components/vue-ps'


import CKEditor from '@ckeditor/ckeditor5-vue';
import '@ckeditor/ckeditor5-build-classic/build/translations/tr';
Vue.use( CKEditor );

/* ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|  THIRD PARTS LIBS   |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ */
import VueI18n from 'vue-i18n'
import moment from 'moment-timezone'
import Fullscreen from 'vue-fullscreen'
import VueResize from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'
import 'flag-icon-css/css/flag-icon.css'
import FormWizard from 'vue-form-wizard'
import '../src/assets/js/formWizard'
import VueTheMask from 'vue-the-mask'
import VueCookie from 'vue-cookies'
import Peity from 'vue-peity'


/* ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|     CORE ASSETS     |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ */
//import './assets/scss/element-variables.scss'
import './assets/scss/global.scss'
import 'flex.box'
import 'animate.css'
//import '../node_modules/mdi/scss/materialdesignicons.scss'
import '../node_modules/@mdi/font/css/materialdesignicons.min.css'
import Affix from './directives/affix'
import App from './App.vue'
import router from './router/'
import store from './store'
import i18n_messages from './i18n.json'
import VueGoodWizard from 'vue-good-wizard';
Vue.use(VueGoodWizard);
Vue.config.productionTip = false;

import VueAnalytics from 'vue-analytics';
// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: 'UA-139623233-2',
    router
});




/* ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|  THIRD PARTS COMPONENTS |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ */
Vue.use(VueResize);
Vue.use(Fullscreen);
Vue.use(VueI18n);
Vue.use(FormWizard);
Vue.use(VueTheMask);
Vue.use(VueCookie);

/* ═ ═ ═ ═ ═ ═ ═ ═ *\
|  CORE COMPONENTS  |
\* ═ ═ ═ ═ ═ ═ ═ ═ */
Vue.use(Element, {locale});
Vue.use(vClickOutside);
Vue.use(VueFloatLabel);
Vue.use(Vuebar);
Vue.component('vue-scroll', VuePerfectScrollbar);
Vue.component('Peity', Peity)
Vue.directive('affix', Affix);

const i18n = new VueI18n({locale: 'tr', messages: i18n_messages});
const sqlapi = "http://localhost:8080/";

new Vue({
    i18n,
    sqlapi,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
